import styled from "styled-components";

export const LPSubmitButton = styled.button`
  background-color: #3f50f6;
  border-radius: 3px;
  margin-top: 20px;
`;
